<template>
  <div class="p-4">
    <div v-if="loading" class="flex justify-center items-center pt-16">
      <span class="loading loading-ring loading-lg" />
    </div>
    <template v-else>
      <div class="flex justify-end">
        <button class="btn rounded btn-xs" @click="createModalShow = true">
          {{ $t("Buttons.createStory") }}
        </button>
      </div>
      <div class="grid grid-cols-2 gap-3 overflow-y-auto pb-10">
        <story-book-list-item1
          v-for="item in storyBookStore.allStoryBookList"
          :key="item.id"
          :story-book="item"
          show-draft
          @click="
            $router.push({
              name: 'storyBookHome',
              params: { uuid: item.uuid },
            })
          "
        />
      </div>
    </template>
    <create-story-book-guide v-model:show="createModalShow" />
  </div>
</template>
<script setup lang="ts">
import { useStoryBook } from "@/stores/story-book";
import { onMounted, ref } from "vue";

const createModalShow = ref(false);
const storyBookStore = useStoryBook();
const loading = ref(false);

onMounted(async () => {
  loading.value = true;
  await storyBookStore.getStoryBookList();
  loading.value = false;
});
</script>
